import React from "react";
// Components
import VerifySession from "../../../config/verifySession";
import AdminValidation from "../../../config/adminValidation";
import CreateCodeComponent from "../../../components/codesManagement/sections/createCode";

const CreateCodeView = () => (
  <>
    {VerifySession()}
    {AdminValidation()}
    <CreateCodeComponent />
  </>
);

export default CreateCodeView;
